import { render, staticRenderFns } from "./newsletterFS.vue?vue&type=template&id=8bd91d00"
import script from "./newsletterFS.vue?vue&type=script&lang=js"
export * from "./newsletterFS.vue?vue&type=script&lang=js"
import style0 from "./newsletterFS.vue?vue&type=style&index=0&id=8bd91d00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports